<template>
  <ul class="navbar-nav mb-2 mb-lg-0">
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        MENU
      </a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
        <li><a class="dropdown-item pointer" @click="router.push({ path: '/'})">Home</a></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'myorganization'})">My Organization</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'annualreports'})">Annual Reports</a></li>
        <li v-if="showHceMenuItem"><a class="dropdown-item pointer" @click="router.push({ name: 'hcetransactions'})">HCE Transactions</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="store.logout()">Sign Out</a></li>
      </ul>            
    </li>
  </ul>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ORGANIZATION_TYPES } from '@/utils/constants';

const store = useAuthStore();
const router = useRouter();

const showHceMenuItem = computed(() => {
  return store.user.primaryOrganizationTypes &&
    (store.user.primaryOrganizationTypes.includes(ORGANIZATION_TYPES.DI) || store.user.primaryOrganizationTypes.includes(ORGANIZATION_TYPES.FOSC));
});

// const viewMyOrganization = () => {
//   ;
// };

</script>

